import { useEffect } from 'react'

export default function useDelayToCall(callback: () => void, delay: number) {
  useEffect(() => {
    const timer = setTimeout(() => {
      callback()
    }, delay)
    return () => {
      clearTimeout(timer)
    }
  }, [])
}
